import { createSlice } from '@reduxjs/toolkit';
import { processAppointments, processVisitData } from 'utils';
import { createAsyncAction } from '../action/index';

const getDashboardData = createAsyncAction('getDashboardData', 'getDashboardData');

interface InitialState {
  appointments: any[],
  visits: any[],
  doctors: any[];
  count: any;
  isFetching: boolean,
}

const initialState = {
  appointments: [],
  visits: [],
  doctors: [],
  count: {},
  isFetching: false,
} as InitialState;

export const counterSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    updateDashboardState: (state, action) => Object.assign(state, action.payload),
  },
  extraReducers: {
    [getDashboardData.pending as any]: (state) => {
      state.isFetching = true;
      state.count = {};
    },
    [getDashboardData.fulfilled as any]: (state, { payload }) => {
      const {
        appointments = [],
        count = {},
        doctorDetails = [],
        visit = [],
      } = payload?.user || {};
      state.appointments = appointments ? processAppointments(appointments).appointments : [];
      state.visits = visit ? processVisitData(visit).visits : [];
      state.count = count;
      state.doctors = doctorDetails;
      state.isFetching = false;
    },
    [getDashboardData.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError')
        state.isFetching = false;
    },
  },
});

// const { updateAppointmentState } = counterSlice.actions;
export {
  getDashboardData,
};
export default counterSlice.reducer;